export default __webpack_public_path__ + "static/section4_feature2-5d7f3116eb5cede42d5beaaecc231d8c.png";